import { Popover, Grid } from 'antd';
import { ReactComponent as Info } from '../../../../Icons/info-outlined.svg';
import styles from './PortalButton.module.scss';

const { useBreakpoint } = Grid;

function PortalContent() {
	return (
		<div className={styles.findPortal}>
			<div className={styles.findPortal__title}>Find your portal</div>

			<div className={styles.findPortal__info}>
				<p>
					Your login URL looks like this:{' '}
					<span className={styles.url}>system.venza.io/company</span>
				</p>

				<p>
					Replace <strong>"company"</strong> with your organization's
					name.
				</p>
			</div>

			<div className={styles.findPortal__help}>
				<p className={styles.findPortal__helpTitle}>Need Help?</p>
				<p>If you don't know your organization's login URL:</p>
				<ul>
					<li>Contact your organization's Venza administrator</li>
					<li>Reach out to your IT support team</li>
				</ul>
			</div>
		</div>
	);
}

function PortalButton() {
	const screens = useBreakpoint();
	const isMobile = !screens.md;

	return (
		<Popover
			style={{ color: '#000' }}
			overlayInnerStyle={{
				width: isMobile ? 290 : 515,
				padding: isMobile ? 0 : '12px 8px',
				backgroundColor: 'white'
			}}
			trigger="click"
			content={<PortalContent />}
		>
			<div
				className={styles.root}
				role="button"
				tabIndex={0}
				aria-label="Find your portal"
			>
				<Info aria-hidden="true" />
				<span>Looking for your portal?</span>
			</div>
		</Popover>
	);
}

export default PortalButton;
